__webpack_require__.p = "/r-type-tactics/";